export default __webpack_public_path__ + "static/media/mode-52.159622cc.svg";